import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.maritalStatus;

const getMaritalStatus = createSelector(getData, status => values(status));

export default getMaritalStatus;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getMaritalStatus.js